<mat-card class="dm__card">
    <p8-layout-settings-header [titlePath]="[formModel?.nom, 'Gestion des listes prédéfinies pour les avis']"
                               [iconRacine]="'checklist'">
    </p8-layout-settings-header>
  <mat-card-content>
    <mat-card-subtitle>
      Cette interface vous permet de gérer vos listes prédéfinies de sollicités qui serviront pour les requêtes d'avis sur une demande concernant le formulaire "{{formModel?.nom || ''}}".
    </mat-card-subtitle>
    <div fxLayoutAlign="end">
      <mat-card-actions align="end">
        <button mat-raised-button (click)="openAddList()"
                aria-disabled="false" color="accent"
                matTooltipPosition="right" matTooltip="Créer une liste prédéfinie de personnes à solliciter pour les avis">
          <i class="fa fa-plus"></i> Créer une liste prédéfinie pour ce formulaire
        </button>
      </mat-card-actions>
    </div>
    <mark *ngIf="countList === 0">Aucune liste de créer pour l'instant</mark>
    <app-data-table *ngIf="formModel"
                    [actions]="actions"
                    [columns]="columns"
                    [dataSource]="dsFormListRequesters"
                    [extraParams]="extraParams"
                    [filterDisplay]="true"
                    [flexAction]="5"
                    [flexColumn]="90"
                    [minFilter]="1" [pageSize]="10"
                    [pageSizesList]="[5,10,25]"
                    [placeHolderFilter]="'Rechercher des listes'"
                    [toolTipFilter]="'Rechercher des listes'"
                    [refreshButton]="false"
                    [refreshIcone]="true"
                    [showFirstLastButtons]="true"
                    [showLoader]="true"
    >
    </app-data-table>
  </mat-card-content>
</mat-card>
